// GENERAL
export const BRDGE_PROJECT_ID = "wg3";

// LOCALES
export const AVAILABLE_LOCALES = ["en", "de", "fr", "it"];
export const CLOUDFLARE_CUSTOMER = "customer-86fwfg7ayixwen07.cloudflarestream.com"
export const DEFAULT_LOCALE = "de";
